export const COOKIE_NAMES = {
  anonymousId: 'anonymousID',
  experimentAllocation: 'alloc',
  facebookClickId: '_fbc',
  facebookPixelBrowserId: '_fbp',
  googleAnalyticsClientId: '_ga',
  isInternalUser: 'isInternalUser',
  segmentAnalyticsAnonymousId: 'ajs_anonymous_id',
  userIpAddress: 'user-ip',
} as const

export const URL_OF_CUSTOM_PROXY_FOR_SEGMENT_CDN =
  'https://data-cdn.comparecredit.com'
